(function () {
  'use strict';

  var DAY_INDEX = {
    Sun: 0,
    Mon: 1,
    Tue: 2,
    Wed: 3,
    Thu: 4,
    Fri: 5,
    Sat: 6
  };

  function asBoolean(value) {
    return value === 'true';
  }

  function parseTime(value) {
    var match = String(value || '').trim().match(/^(\d{1,2}):(\d{2})$/);

    if (!match) return null;

    var hours = Number(match[1]);
    var minutes = Number(match[2]);

    if (hours > 23 || minutes > 59) return null;

    return hours * 60 + minutes;
  }

  function zonedParts(date, timeZone) {
    try {
      var parts = new Intl.DateTimeFormat('en-US', {
        timeZone: timeZone,
        weekday: 'short',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hourCycle: 'h23'
      }).formatToParts(date).reduce(function (result, part) {
        result[part.type] = part.value;
        return result;
      }, {});

      if (DAY_INDEX[parts.weekday] === undefined) return null;

      return {
        day: DAY_INDEX[parts.weekday],
        date: parts.year + '-' + parts.month + '-' + parts.day,
        minutes: Number(parts.hour) * 60 + Number(parts.minute)
      };
    } catch (error) {
      return null;
    }
  }

  function validISODate(value) {
    var match = String(value || '').trim().match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (!match) return null;

    var year = Number(match[1]);
    var month = Number(match[2]);
    var day = Number(match[3]);
    var probe = new Date(Date.UTC(year, month - 1, day));

    if (probe.getUTCFullYear() !== year || probe.getUTCMonth() !== month - 1 || probe.getUTCDate() !== day) {
      return null;
    }

    return match[1] + '-' + match[2] + '-' + match[3];
  }

  function nextISODate(value) {
    var validDate = validISODate(value);
    if (!validDate) return null;

    var parts = validDate.split('-').map(Number);
    var next = new Date(Date.UTC(parts[0], parts[1] - 1, parts[2] + 1));
    return next.toISOString().slice(0, 10);
  }

  function dateSchedules(root) {
    return Array.prototype.map.call(root.querySelectorAll('[data-live-popup-date-entry]'), function (entry) {
      return {
        date: validISODate(entry.dataset.date),
        start: parseTime(entry.dataset.start),
        end: parseTime(entry.dataset.end),
        url: String(entry.dataset.url || '').trim()
      };
    }).filter(function (entry) {
      return entry.date && entry.start !== null && entry.end !== null;
    });
  }

  function matchingDateSchedule(root, current) {
    return dateSchedules(root).find(function (entry) {
      if (entry.start === entry.end) return current.date === entry.date;

      if (entry.start < entry.end) {
        return current.date === entry.date && current.minutes >= entry.start && current.minutes < entry.end;
      }

      return (current.date === entry.date && current.minutes >= entry.start) ||
        (current.date === nextISODate(entry.date) && current.minutes < entry.end);
    }) || null;
  }

  function isWithinDateSchedule(root, current) {
    return Boolean(matchingDateSchedule(root, current));
  }

  function activeDateSchedule(root, date) {
    var timezone = root.dataset.timezone || 'America/Sao_Paulo';
    var current = zonedParts(date, timezone);
    return current ? matchingDateSchedule(root, current) : null;
  }

  function safeDestination(value) {
    var destination = String(value || '').trim();
    if (/^https?:\/\//i.test(destination) || /^\//.test(destination)) return destination;
    return '';
  }

  function isWithinSchedule(root, date) {
    var timezone = root.dataset.timezone || 'America/Sao_Paulo';
    var current = zonedParts(date, timezone);

    if (!current) return false;
    if (asBoolean(root.dataset.hasDateSchedule)) return isWithinDateSchedule(root, current);

    var start = parseTime(root.dataset.startTime);
    var end = parseTime(root.dataset.endTime);
    if (start === null || end === null) return false;

    var selectedDays = [
      asBoolean(root.dataset.daySunday),
      asBoolean(root.dataset.dayMonday),
      asBoolean(root.dataset.dayTuesday),
      asBoolean(root.dataset.dayWednesday),
      asBoolean(root.dataset.dayThursday),
      asBoolean(root.dataset.dayFriday),
      asBoolean(root.dataset.daySaturday)
    ];

    if (start === end) return selectedDays[current.day];

    if (start < end) {
      return selectedDays[current.day] && current.minutes >= start && current.minutes < end;
    }

    var previousDay = (current.day + 6) % 7;
    return (selectedDays[current.day] && current.minutes >= start) ||
      (selectedDays[previousDay] && current.minutes < end);
  }

  function storageKey(root) {
    return 'live-shopping-popup:' + root.id;
  }

  function wasOpenedThisSession(root) {
    try {
      return window.sessionStorage.getItem(storageKey(root)) === '1';
    } catch (error) {
      return false;
    }
  }

  function markOpenedThisSession(root) {
    try {
      window.sessionStorage.setItem(storageKey(root), '1');
    } catch (error) {
      // Private browsing can block sessionStorage; the popup still works.
    }
  }

  function init(root) {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    if (root.dataset.enabled !== 'true' && !(window.Shopify && window.Shopify.designMode)) return;

    var launcher = root.querySelector('[data-live-popup-open]');
    var overlay = root.querySelector('[data-live-popup-close]');
    var dialog = root.querySelector('.live-shopping-popup__dialog');
    var closeButton = root.querySelector('.live-shopping-popup__close');
    var cta = root.querySelector('[data-live-popup-cta]');
    var isOpen = false;
    var wasActive = false;
    var previousOverflow = '';
    var intervalId;
    var backgroundState = [];

    if (!launcher || !overlay || !dialog || !closeButton || !cta) return;

    function updateCta(schedule) {
      var destination = safeDestination(schedule && schedule.url) || safeDestination(root.dataset.defaultUrl);

      if (destination) {
        cta.setAttribute('href', destination);
        cta.removeAttribute('aria-disabled');
        cta.removeAttribute('tabindex');
        cta.classList.remove('live-shopping-popup__cta--disabled');
        return;
      }

      cta.removeAttribute('href');
      cta.setAttribute('aria-disabled', 'true');
      cta.setAttribute('tabindex', '-1');
      cta.classList.add('live-shopping-popup__cta--disabled');
    }

    function closePopup(restoreFocus) {
      if (!isOpen) return;

      isOpen = false;
      dialog.hidden = true;
      overlay.hidden = true;
      launcher.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = previousOverflow;
      backgroundState.forEach(function (item) {
        item.element.inert = item.inert;
      });
      backgroundState = [];

      if (restoreFocus) launcher.focus();
    }

    function openPopup(isAutomatic) {
      if (isOpen) return;
      if (isAutomatic && asBoolean(root.dataset.showOnce) && wasOpenedThisSession(root)) return;

      isOpen = true;
      dialog.hidden = false;
      overlay.hidden = false;
      launcher.hidden = false;
      launcher.setAttribute('aria-expanded', 'true');
      previousOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';

      var container = root;
      while (container.parentElement && container.parentElement !== document.body) {
        container = container.parentElement;
      }
      Array.prototype.forEach.call(document.body.children, function (element) {
        if (element !== container && element.tagName !== 'SCRIPT') {
          backgroundState.push({ element: element, inert: element.inert });
          element.inert = true;
        }
      });

      if (isAutomatic && asBoolean(root.dataset.showOnce)) markOpenedThisSession(root);

      window.requestAnimationFrame(function () {
        closeButton.focus();
      });
    }

    function update() {
      var enabled = asBoolean(root.dataset.enabled);
      var inThemeEditor = window.Shopify && window.Shopify.designMode;
      var forceLive = asBoolean(root.dataset.forceLive);
      var now = new Date();
      var usesDates = asBoolean(root.dataset.hasDateSchedule);
      var activeDate = usesDates ? activeDateSchedule(root, now) : null;
      var activeBySchedule = usesDates ? Boolean(activeDate) : isWithinSchedule(root, now);
      var active = enabled && (inThemeEditor || forceLive || activeBySchedule);

      updateCta(activeDate);

      if (!active) {
        launcher.hidden = true;
        closePopup(false);
        wasActive = false;
        return;
      }

      launcher.hidden = false;

      if (!wasActive && asBoolean(root.dataset.openOnEntry)) {
        openPopup(true);
      }

      wasActive = true;
    }

    launcher.addEventListener('click', function () {
      openPopup(false);
    });

    cta.addEventListener('click', function (event) {
      if (cta.getAttribute('aria-disabled') === 'true') event.preventDefault();
    });

    root.querySelectorAll('[data-live-popup-close]').forEach(function (element) {
      element.addEventListener('click', function () {
        closePopup(element === closeButton || element === overlay);
      });
    });

    function handleKeydown(event) {
      if (!isOpen) return;

      if (event.key === 'Escape') {
        closePopup(true);
        return;
      }

      if (event.key !== 'Tab') return;

      var focusable = dialog.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])');
      if (!focusable.length) return;

      var first = focusable[0];
      var last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    function handleVisibilityChange() {
      update();
    }

    function handlePageshow() {
      update();
    }

    function handleSectionUnload(event) {
      var sectionId = event.detail && event.detail.sectionId;
      if (sectionId && root.id.indexOf(sectionId) === -1) return;

      window.clearInterval(intervalId);
      document.removeEventListener('keydown', handleKeydown);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      window.removeEventListener('pageshow', handlePageshow);
      document.removeEventListener('shopify:section:unload', handleSectionUnload);
      closePopup(false);
    }

    document.addEventListener('keydown', handleKeydown);
    document.addEventListener('visibilitychange', handleVisibilityChange);
    window.addEventListener('pageshow', handlePageshow);
    document.addEventListener('shopify:section:unload', handleSectionUnload);
    intervalId = window.setInterval(update, 15000);
    update();
  }

  function initAll() {
    document.querySelectorAll('[data-live-shopping-popup]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
}());
